module.exports = __webpack_public_path__ + "static/media/sample-solo.48563cec.png";